<template>
  <div class="field">
    <div class="control has-icons-right">
      <input autocomplete="off" :value="value" @input="emitSearchStringUpdate($event.target.value)"
             class="input" type="text" name="search" :placeholder="placeHolder"/>
      <span class="icon is-small is-right"><i class="fas fa-search"></i></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchField',
  props: {
    placeHolder: {
      type: String,
      default: 'Search'
    },
    value: ''
  },
  methods: {
    emitSearchStringUpdate (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>

<style scoped>
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  opacity: 0.4;
  font-size: 12px;
  color: #58595b;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  opacity: 0.4;
  font-size: 12px;
  color: #58595b;
}

::-ms-input-placeholder { /* Microsoft Edge */
  opacity: 0.4;
  font-size: 12px;
  color: #58595b;
}

.input {
  color: #58595B;
  font-size: 11px;
  padding: 14px 15px 19px;
  border-radius: 1px;
  border: solid 1px rgba(88, 89, 91, 0.32);
}

.control.has-icons-right .icon {
  color: rgba(88, 89, 91, 0.32);
  font-size: 14px;
  width: 31px;
  padding-top: 4px
}

.control.has-icons-right .input:focus ~ .icon, .control.has-icons-right .select:focus ~ .icon {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchField.vue